<template>
  <AssetsDeleted v-bind="{ columns, items, modal, plural: 'currencies' }" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { ModalClass } from '@types'

import { ASSET_FIELD, ASSET_FIELD_LABEL } from '@/entities/assets/utils/const'

import useFiltersService from '@/services/filters'

import { useAssetsDeletedStore } from '@/store/assets/deleted'

import AssetsDeleted from '@/modules/modals/AssetsDeleted.vue'

type Props = {
  modal: ModalClass<any>
}
defineProps<Props>()

const assetsDeletedStore = useAssetsDeletedStore()

const { fetchOptions } = useFiltersService()

const columns = computed(() => [
  {
    name: ASSET_FIELD.NAME,
    caption: ASSET_FIELD_LABEL[ASSET_FIELD.NAME],
    filter: {
      getter: () => fetchOptions('Currencies', ASSET_FIELD.NAME),
    },
  },
  {
    name: ASSET_FIELD.TICKER,
    caption: ASSET_FIELD_LABEL[ASSET_FIELD.TICKER],
    filter: {
      getter: () => fetchOptions('Currencies', ASSET_FIELD.TICKER),
    },
  },
])

const items = computed(() => assetsDeletedStore.getCurrencies)
</script>
